import api from './api';

export const getDocumentNumberSeries = async (params = {}) => {
  const response = await api.get('/configuration/document-number-series', { params });
  return response.data;
};

export const getActiveDocumentNumberSeries = async (params = {}) => {
  const response = await api.get('/documents/auto-series', { params });
  return response.data;
};

export const peekDocumentNumberSeriesNext = async (series, documentType = null) => {
  const response = await api.get('/documents/auto-series/next', {
    params: {
      series,
      ...(documentType ? { document_type: documentType } : {}),
    },
  });
  return response.data;
};

export const createDocumentNumberSeries = async (payload) => {
  const response = await api.post('/configuration/document-number-series', payload);
  return response.data;
};

export const updateDocumentNumberSeries = async (id, payload) => {
  const response = await api.put(`/configuration/document-number-series/${id}`, payload);
  return response.data;
};

export const syncDocumentNumberSeriesFromDocuments = async (id) => {
  const response = await api.post(`/configuration/document-number-series/${id}/sync-from-documents`);
  return response.data;
};

export const deleteDocumentNumberSeries = async (id) => {
  const response = await api.delete(`/configuration/document-number-series/${id}`);
  return response.data;
};
